import type { AdsConfig } from '@anon-chat/shared';
import { isTelegramMode } from './app-mode';

/**
 * Заголовки и описание страницы, заданные в панели.
 *
 * Применяются в рантайме: приложение отдаётся статикой, подставить их на
 * сервере негде. Поисковые роботы сегодня исполняют JavaScript, но не все и не
 * сразу — значения по умолчанию остаются в index.html, чтобы страница не
 * оказалась безымянной для тех, кто скрипты не выполняет.
 */
export interface PageSettings {
  title: string | null;
  h1: string | null;
  description: string | null;
  /** Рекламные места: код на устройство, экраны боковых полос, всплывающий. */
  ads: AdsConfig;
  /** Кнопка «Сообщить о проблеме» в диалоге. */
  issuesEnabled: boolean;
  adsgramEnabled: boolean;
  adsgramBlockId: string | null;
  adsgramOnChatEnd: boolean;
  adsgramOnSearchStart: boolean;
  adsgramMinIntervalSec: number;
}

const API_URL = import.meta.env.VITE_API_URL ?? '/api';

export async function loadPageSettings(): Promise<PageSettings | null> {
  try {
    const surface = isTelegramMode ? 'WEBAPP' : 'WEB';
    const response = await fetch(`${API_URL}/settings/page?surface=${surface}`);
    if (!response.ok) {
      return null;
    }
    return (await response.json()) as PageSettings;
  } catch {
    // Настройки — украшение: без них страница работает на значениях сборки.
    return null;
  }
}

export function applyPageSettings(settings: PageSettings): void {
  if (settings.title) {
    document.title = settings.title;
  }

  if (settings.description) {
    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'description';
      document.head.appendChild(tag);
    }
    tag.content = settings.description;
  }
}
